import type { Translations } from '~/translations/Model'

const nn: Translations = {
  aschehoug: 'Aschehoug',
  application: 'Aunivers',
  reset: 'Start på nytt',
  next: 'Neste',
  previous: 'Førre',
  of: 'av',
  loading: 'Laster...',
  logout: 'Logg ut',
  back: 'Tilbake',
  backTo: 'Tilbake til {name}',
  backToQuote: 'Tilbake til «{name}»',
  save: 'Lagre',
  cancel: 'Avbryt',
  error: 'Noko gjekk gale!',
  jumpToContent: 'Hopp til hovudinnhald',
  help: 'Hjelp',
  resource: 'Ressurs',
  resourceCenter: 'Opne hjelpesenter',
  close: 'Lukk',
  open: 'Opne',
  download: 'Last ned',
  downloadIn: 'Last ned ({in})',
  visitIn: 'Besøk {in}',
  recommendedContent: 'Foreslått innhald',
  remove: 'Fjern',
  unknownError: 'Noko gjekk gale dessverre. Prøv igjen seinare.',
  noneSelected: 'Ingen vald',
  relatedContent: 'Relatert innhald',
  new: 'Nytt',
  beta: 'Beta',
  newShort: 'Ny',
  coming: 'Kommer',
  preview: 'Førehandsvis',
  breadcrumbs: 'Brødsmulesti',
  copyrightBtn: 'Opphavsrett',
  teacher: 'Lærar',
  clear: 'Nullstill',
  offline: 'Ingen internettsamband',
  readMoreAt: 'Les meir her',
  closeDialog: 'Lukk dialog',
  dialogDescription: 'Dialogvindauge for {title}',
  copyCode: 'Kopier kode',
  credit: 'Kreditering',
  bookCorrections: 'Rettingar til boka',
  filesForDownload: 'Filer til nedlasting',
  login: {
    slogan: 'Med læraren. For eleven.',
    title: 'Logg inn',
    welcome: 'Velkommen til Aunivers',
    intro: 'For å sjå læremidla må du logga inn',
    withServiceProvider: 'Med Feide',
    withLocalProvider: 'Logg inn utan Feide',
    logout: 'Logg ut',
    news: 'Aktuelt',
    more: 'Meir om aunivers.no',
    trialHeading: 'Få gratis tilgang i 30 dagar!',
    trialText: 'Bestill prøvelisens og test ut alt vårt faginnhald og dessutan plussproduktet Biblioteket, heilt gratis!',
    trialCta: 'Prøv gratis',
    error: {
      title: 'Feil ved innlogging',
      unknown: 'Noko gjekk gale i systema våre. Ver vennleg og prøv igjen.',
    }
  },
  time: {
    week: 'Veke',
    weekWithNumber: 'Veke {number}',
    relative: {
      recently: 'Nyleg',
      today: 'I dag',
      yesterday: 'I går',
      thisWeek: 'Denne veka',
      lastWeek: 'Førre veke',
      minutesAgo: 'for {n} minutt sidan',
      hoursAgo: 'for {n} timar sidan',
      daysAgo: 'for {n} dagar sidan',
    },
  },
  http: {
    404: {
      code: '404',
      message: 'Ikkje funne',
    },
  },
  notFound: {
    title: 'Finst ikkje',
    heading: 'Ooops!',
    message: 'Innhaldet kan vera fjerna, eller du kan mangla tilgang.',
    buttonText: 'Tilbake til framsida',
    statusCode: 'Statuskode: {code}',
  },
  calendar: {
    title: 'Kalender',
    messages: {
      noResults: 'Ingen resultat',
      noResultsInWeekSwitcher: {
        message: 'Ingen oppgåver planlagde i veke {number} for {grade}',
        solution: 'Prøv å byta gruppe, trinn eller veke. Legg til ved å trykkja på \'Se flere oppgaver\'',
      },
      noResultsDescription: 'Fann ingen veker med innhald i vald periode',
      noWeekResources: 'Fann ingen ressursar denne veka',
      noResourcesInPeriod: 'Fann ingen ressursar i vald periode.',
      periodUpdated: 'Periode oppdatert',
      periodUpdateError: 'Kunne ikkje oppdatere periode',
      periodCreated: 'Periode opprettet',
      periodCreateError: 'Kunne ikkje opprette periode',
    },
    updatePlan: {
      titlePlaceholder: 'Tittel',
      bodyPlaceholder: 'Beskrivelse',
      dialogTitle: 'Rediger periode',
      save: 'Lagre',
      change: 'Rediger',
      cancel: 'Avbryt',
      delete: 'Slett',
    },
    createPeriod: {
      titlePlaceholder: 'Tittel',
      bodyPlaceholder: 'Beskrivelse',
      new: 'Ny periode',
      dialogTitle: 'Opprett periode',
      startWeek: 'Start-veke',
      endWeek: 'Slutt-veke',
      create: 'Opprett',
      abort: 'Avbryt',
      delete: 'Slett',
    },
    note: {
      teacher: 'Skriv notat',
      studentShow: 'Sjå notat frå lærer',
      studentHide: 'Skjul notat frå lærer',
    },
    yearPlan: {
      sharedYearPlans: 'Kollegers planer',
    },
    errors: {
      loadYearPlans: 'Noko gjekk gale ved lasting av årsplanar',
      loadSharedYearPlans: 'Noko gjekk gale ved lasting av foreslåtte årsplanar',
      loadPlans: 'Noko gjekk gale ved lasting av planar',
    },
  },
  groups: {
    groups: 'Grupper',
    removeSelectedGroup: 'Fjern gruppeval',
    active: 'Aktiv',
    activeTitle: 'Aktiv gruppe',
    title: 'Ingen klasse valt | {count} klassar valde',
    dialogBody: 'Vel kva fag og trinn du planlegg for.',
    missingSubject: 'Gruppa manglar eit tilkopla fag',
    confirmData: 'Stadfest fag og trinn',
    readOnlyBody: 'Gruppa er koblet til {grade}. For å endra, ta kontakt med {admins}',
    noGrades: 'Ingen trinn funne',
    noSubjects: 'Ingen fag funne',
    saveGroup: 'Lagre gruppe',
    editGroup: 'Rediger',
    deleteGroup: 'Slett',
    newGroup: 'Ny gruppe',
    noGroup: 'Manglar aktiv gruppe',
    chooseGroup: 'Vel ei aktiv gruppe i toppmenyen for å sjå planlagde ressursar.',
    cancel: 'Avbryt',
    noSave: 'Gå til fagside',
    saveError: 'Feil ved lagring av gruppe',
    saveSuccess: 'Gruppa vart lagra',
    createSuccess: 'Gruppen «{name}» vart oppretta',
    nonWriteable: 'Grupper frå Feide kan ikkje redigerast i Aunivers',
    nonAdminGroup: 'For å endra på gruppa må du ta kontakt med ein administrator',
    nonAdminContact: 'For å endra på gruppa må du ta kontakt med {admins}',
    membersCount: '{count} medlemmer',
    members: 'Medlemmer',
    addMember: 'Legg til medlem i gruppa',
    addMemberShort: 'Legg til',
    removeMember: 'Fjern medlem frå gruppa',
    grade: 'Trinn',
    groupName: 'Gruppenamn',
    types: {
      basis: 'Klassar (Hentet frå Feide)',
      teaching: 'Undervisningsgrupper',
      other: 'Grupper (Laget i Aunivers)',
    },
    userSearch: {
      search: 'Søk etter brukarar',
      searching: 'Søker...',
      noResults: 'Ingen resultat',
      error: 'Noe gikk galt',
      placeholder: 'Søk etter elevar eller lærarar...',
    },
    groupDeleted: 'Gruppen vart sletta',
    groupDeleteError: 'feil ved sletting av gruppe',
    noGradesConnected: 'Ingen tilkopla trinn eller fag',
    admin: 'Lærer',
    groupDeleteConfirm: 'Er du sikker på at du vil slette denne gruppa?',
    groupNamePlaceholder: 'Skriv gruppenamn...',
    noLocalGroups: 'Du har ingen Aunivers grupper endå. <br> Trykk på "Ny gruppe" for å lage ein.',
    noGroups: 'Du har ingen klassar eller grupper tilkopla til brukar. Byrj å lage grupper anten i Feide eller ved å trykkje "Ny gruppe" nedanfor.',
    noGroupsTitle: 'Manglar grupper',
    copyGroup: 'Kopier',
    copyOf: '{groupName} (kopi)',
  },
  header: {
    chooseGroup: 'Vel gruppe',
    showMenu: 'Vis sidemeny',
    notFound: 'Ingen ressursar funne for {grade}',
    teacherGuide: {
      teacherGuide: 'Lærarrettleiing',
      teacherGuideFor: 'Lærarrettleiing: {title}',
      tip: 'Tips',
    },
  },
  settings: {
    title: 'Innstillingar',
    roleTeacher: 'Lærer hos',
    roleStudent: 'Elev ved',
    roleAtOrganization: '{role} {organization}',
    updated: 'Innstillingar lagra!',
    activeGroup: 'Du har ei aktiv gruppe ({groupName})',
    missingGrade: 'Gruppa di manglar eit tilkopla trinn',
    missingSubject: 'Gruppa di manglar eit tilkopla fag',
    changeSubjectInfo: 'Du kan framleis redigera kva fag du vil ha synleg på framsida!',
    groupInfo: 'Grupper gjer det enklare å navigera rett innhald! Derfor kryssar me automatisk av på innstillingane nedanfor basert på trinn og fag kopla til gruppa di',
    chooseGrade: 'Vel skuleslag for å sjå relaterte fag',
    chooseGradeToClose: 'Du må velje eit skuleslag',
    chooseGradeType: 'Vel eit skuleslag',
    gradeTypeWarning: 'Noko er ikkje heilt rett. Trykk på "Innstillinger" for å velja skuleslaget ditt.',
    readOnlyGradesSpansAcrossgradeTypes: {
      title: 'Feide-trinn på tvers av skuleslag',
      info: 'Dine Feide-trinn dekkjer fleire skuleslag. Alle valde trinn blir viste når du vel skuleslag, og byter du skuleslag, blir trinna for det skuleslaget også tilgjengelege i *Aunviers, saman med trinna frå Feide.',
    },
    sections: {
      gradeType: 'Skuleslag',
      language: 'Målform',
      display: 'Visningsval',
      instruction: 'Undervisning',
      tts: 'Talesyntese',
    },
    drawers: {
      customization: 'Trinn og fag',
      language: 'Språk',
      groups: 'Klassar og grupper',
      plans: 'Foreslåtte planar',
      licenses: 'Lisensar',
      shortcuts: 'Snarveier',
      subscription: 'Abonnement',
    },
    shortcuts: {
      digitalBooks: 'Unibok - Digitale bøker',
      oldContent: 'Innhald frå Lokus (LK-06)',
    },
    vgsWeirdness: {
      cantRemoveLastSelected: 'Du kan ikkje fjerne det siste valde trinnet. Vel heller eit anna skuleslag.',
    },
  },
  wizard: {
    warningTitle: 'Vent litt!',
    warningText: 'Vel både skuleslag og fag før du lukkar vindauget.',
    nextStep: 'Neste',
    prevStep: 'Forrige',
    step: 'Steg {activeStep} av {steps}',
    finish: 'Fullfør',
    grades: 'Vel kva skuleslag du underviser på',
    subjects: 'Kva fag ønskjer du å sjå?',
    language: 'Vel føretrekt målform',
  },
  licenses: {
    title: 'Lisensar',
  },
  home: {
    title: 'Heim',
    welcome: 'Velkommen til Aunivers!',
    yourSubjects: 'Faga dine',
    yourProducts: 'Produkta dine',
    yourAddons: 'Tilleggsprodukta dine',
    showMoreSubjects: 'Vis fleire fag',
    showLessSubjects: 'Vis færre fag',
    showMoreProducts: 'Vis fleire produkt',
    showLessProducts: 'Vis færre produkt',
    didYouKnow: 'Visste du at:',
    greetings: {
      morning: 'God morgon',
      afternoon: 'God ettermiddag',
      evening: 'God kveld',
      night: 'God natt',
    },
  },
  notifications: {
    title: 'Varsel',
    notification: 'Varsel',
    today: 'I dag',
    thisWeek: 'Siste sju dagar',
    markRead: 'Marker som lese',
    markAllRead: 'Marker alle som lese',
    allNotifications: 'Alle varslar',
    allNotificationsMarkedAsRead: 'Alle varsel vart markerte som lese',
    sentNotifications: 'Sende varslar',
    receivedNotifications: 'Mottekne varsel',
    noNotifications: 'Hurra! Du har ingen nye varsel',
    noReceivedNotifications: 'Du har ingen nye mottekne varsel',
    noSentNotifications: 'Du har ikkje sendt varslar nyleg',
    chooseNotificationType: 'Vel typa varsel',
    viewAll: 'Sjå alle',
    goToResource: 'Gå til ressurs',
    received: 'Motteke',
    sent: 'Sendt',
  },
  metadata: {
    weekdays: {
      monday: 'Måndag',
      tuesday: 'Tysdag',
      wednesday: 'Onsdag',
      thursday: 'Torsdag',
      friday: 'Fredag',
      saturday: 'Laurdag',
      sunday: 'Søndag',
    },
    subscriptionGrades: {
      '1-7': '1–7',
      '8-10': '8–10',
      'vgs': 'VGS',
    },
    gradeTypes: {
      grade1to4: 'Barneskule 1-4',
      grade5to7: 'Barneskule 5-7',
      grade8to10: 'Ungdomsskule',
      gradeVgs: 'Vidaregåande',
      gradeAdult: 'Vaksen',
      gradePrep: 'Forkurs',
      short: {
        grade1to4: '1–4',
        grade5to7: '5–7',
        grade8to10: '8–10',
        gradeVgs: 'Videregående',
        gradeAdult: 'Voksen',
        gradePrep: 'Forkurs',
      }
    },
    grades: {
      aarstrinn1: 'Trinn 1',
      aarstrinn2: 'Trinn 2',
      aarstrinn3: 'Trinn 3',
      aarstrinn4: 'Trinn 4',
      aarstrinn5: 'Trinn 5',
      aarstrinn6: 'Trinn 6',
      aarstrinn7: 'Trinn 7',
      aarstrinn8: 'Trinn 8',
      aarstrinn9: 'Trinn 9',
      aarstrinn10: 'Trinn 10',
      vg1: 'Vg1',
      vg2: 'Vg2',
      vg3: 'Vg3',
      vok: 'Voksen',
      prep: 'Forkurs',
      forkurs: 'Forkurs',
    },
    gradesPunctuated: {
      aarstrinn1: '1. trinn',
      aarstrinn2: '2. trinn',
      aarstrinn3: '3. trinn',
      aarstrinn4: '4. trinn',
      aarstrinn5: '5. trinn',
      aarstrinn6: '6. trinn',
      aarstrinn7: '7. trinn',
      aarstrinn8: '8. trinn',
      aarstrinn9: '9. trinn',
      aarstrinn10: '10. trinn',
      vg1: 'Vg1',
      vg2: 'Vg2',
      vg3: 'Vg3',
      vok: 'Vaksenopplæring',
      forkurs: 'Forkurs',
      prep: 'Forkurs',
    },
    gradesShort: {
      aarstrinn1: '1.',
      aarstrinn2: '2.',
      aarstrinn3: '3.',
      aarstrinn4: '4.',
      aarstrinn5: '5.',
      aarstrinn6: '6.',
      aarstrinn7: '7.',
      aarstrinn8: '8.',
      aarstrinn9: '9.',
      aarstrinn10: '10.',
      vg1: 'vg1',
      vg2: 'vg2',
      vg3: 'vg3',
      vok: 'vok',
      forkurs: 'Forkurs',
      prep: 'forkurs',
    },
    subjects: {
      ENG: 'Engelsk',
      FSP: 'Framandspråk',
      KRO: 'Kroppsøving',
      MAT: 'Matematikk',
      NAT: 'Naturfag',
      FLE: 'Fleirfagleg',
      NOR: 'Norsk',
      SAF: 'Samfunnsfag',
      FYS: 'Fysikk',
      GEO: 'Geografi',
      HEL: 'Helse',
      HIS: 'Historie',
      KJE: 'Kjemi',
      MED: 'Mediefag',
      POL: 'Politikk',
      PSY: 'Psykologi',
      REL: 'Religion og etikk',
      KRL: 'KRLE',
      TVE: 'Året rundt',
      INF: 'Informasjonsteknologi',
      SPA: 'Spansk',
      TYS: 'Tysk',
      FRA: 'Fransk',
      GFG: 'Geofag',
      KHV: 'Kunst og handverk',
      MUS: 'Musikk',
      MHE: 'Mat og helse',
      SOK: 'Sosialkunnskap',
      SOS: 'Sosiologi og sosialantropologi',
      POM: 'Politikk og menneskerettar',
      SAK: 'Samfunnskunnskap',
      SAG: 'Samfunnsgeografi',
      LANG: 'Språkfag',
      REAL: 'Realfag',
      TST: 'Under utvikling',
    },
    language: {
      title: 'Målform',
      nb: 'Bokmål',
      nn: 'Nynorsk',
    },
    taskTypes: {
      article: 'Artikkel',
      video: 'Video',
      audio: 'Lyd',
      file: 'Fil',
      document: 'Dokument',
      task: 'Oppgåve',
      resource: 'Ressurs',
      digitalbook: 'Digitalbok',
      game: 'Spel',
    },
  },
  organization: {
    title: 'Vel ein aktiv skule for økta di',
    choose: 'Vel skule',
  },
  filters: {
    forTeacher: 'Til lærer',
    content: 'Innhald',
    emptyFilter: 'Tøm filter',
    chooseTheme: 'Vel tema',
    chooseTaskType: 'Vel innhaldstype',
    chooseSubject: 'Vel fag',
    chooseGrade: 'Vel trinn',
    chooseGradeType: 'Vel skuleslag',
    chooseGroup: 'Vel gruppe',
    chooseLanguage: 'Vel målform',
    chooseFilters: 'Vis filter',
    hideFilters: 'Skjul filter',
    chooseSorting: 'Vel sortering',
    chooseProduct: 'Vel bok',
    chooseWeekNumber: 'Vel uke',
    chooseHeader: 'Vel tema',
    chooseSchoolYear: 'Vel skuleår',
    noResourcesFound: 'Ingen ressursar funne',
    noProducts: 'Ingen bøker funne',
    noSubjects: 'Ingen fag funne',
    toLegacySubject: 'Gammalt oppsett',
    toNewSubject: 'Nytt oppsett',
    filteredAway: {
      title: 'Fann ingen ressursar',
      messageWithGrades: 'Du kan sjå innhald ved å byta til følgjande trinn:',
      messageWithGradeTypes: 'Du kan sjå innhald ved å byta til følgjande skuleslag:',
      messageWithoutGrades: 'Prøv å endra på filtreringa, eller ta kontakt med kundeservice',
    },
    subject: 'Fag',
    grade: 'Trinn',
    genre: 'Sjanger',
    product: 'Bok',
    header: 'Overskrift',
    taskType: 'Innhaldstype',
    filterSettings: 'Visningsval',
    sortSettings: 'Sorteringsval',
    noHits: 'Oi! Ser ut som filteret ditt ikkje har nokre treff.',
    trySomethingElse: 'Prøv andre kombinasjonar for å få fleire resultat.',
    frontpage: 'Forside {subjectName}',
    settings: {
      suggested: 'Foreslått rekkjefølgje',
      alphabetical: 'Alfabetisk',
      studentActivity: 'Siste elevaktivitet',
      random: 'Tilfeldig sortering',
    },
    values: {
      allSubjects: 'Alle fag',
      allGroups: 'Alle grupper',
      thisWeek: 'Denne veka',
      wholeClass: 'Hele klassen',
      week: {
        previous: 'Førre veke',
        current: 'Denne veka',
        next: 'Neste veke',
        previousFourWeeks: 'Siste fire veker',
        previousThreeMonths: 'Siste tre månader',
        fromSchoolYearStart: 'Sidan skulestart',
        yearplan: 'Sjå årsplan',
      },
    },
  },
  favorite: {
    list: 'Liste',
    favoriteListsPageTitle: 'Lister',
    favoriteListsViewTitle: 'Mine lister',
    save: 'Legg i liste',
    counted: 'Ingen ressursar | 1 ressurs | {number} ressursar',
    addToList: 'Legg i liste',
    addToListSuccess: 'Lagt til i lista',
    createListDialogTitle: 'Ny liste',
    createListButtonName: 'Opprett ny liste',
    favoriteListsBackButton: 'Mine lister',
    favoriteListDropdownLabel: 'Vel liste',
    createListNameLabel: 'Gi lista eit namn',
    createSuccess: 'Ny liste oppretta',
    deleteSuccess: 'Lista vart sletta',
    deleteList: 'Slett lista',
    removeFromList: 'Fjern frå lista',
    removedItemFromListSuccess: '«{name}» fjerna frå {listName}',
    deleteConfirmationText: 'Vil du verkeleg slette «{name}»?',
    editListDialogTitle: 'Endre namn/notat',
    editListNameLabel: 'Gi lista eit nytt namn',
    editListNoteLabel: 'Skriv eit notat for lista (valfritt)',
    editListInfo: 'Endre namn',
    noneCounted: 'Ingen ressursar',
    ownedByMe: 'Lista mi',
    ownedBySomeoneElse: 'Lista til nokre andre',
    sharedWithMe: '{name} har delt lista med deg',
    browseList: 'Bla i lista',
    copyUrl: 'Kopier URL',
    delete: 'Slett',
    updateSuccess: 'Lagra',
    copySuccess: 'Kopiert',
    copyFailure: 'Kunne ikkje kopiera URL',
    navigation: 'Navigasjon i liste',
    navigationDots: 'Liste med ressursar',
    rearrange: 'Trykk pil opp eller ned for å endra rekkjefølgja',
    messageFrom: 'Melding frå <b>{name}</b>',
    duplicateList: 'Dupliser',
    duplicateConfirm: 'Bekreft',
    duplicateViewSuccess: 'Lista vart duplisert, og du ser no på di nye liste',
    duplicateSuccess: 'Lista vart duplisert',
    duplicateConfirmationText: 'Ønskjer du å duplisere denne lista?',
    sharedWith: 'Delt med',
    addLink: 'Legg til lenkje',
    linkName: 'Navn på lenka (valfritt)',
    missingUrl: 'Manglar gyldig URL',
    linkFailure: 'Feil ved oppretting av lenkjen',
    fileNotFound: 'Fila vart ikkje funnen',
    uploadFailure: 'Feil ved opplasting av fila',
    nameTooShort: 'Navn er fort kort',
    fileFailure: 'Feil ved oppretting av fila',
    visitLink: 'Besøk lenkja på {host}',
    limitShort: 'Maksgrensa nådd',
    limitReached: 'Maksgrensa på {limit} stk er nådd',
    externalLink: 'Ekstern lenkje',
    editFavorite: 'Endre namn',
    editSuccess: 'Ressursen vart oppdatert',
    editFailure: 'Noko gjekk gale',
    notFound: 'Ikke funnet',
    note: 'Notat',
  },
  plans: {
    plan: 'Plan',
    plannedThisWeek: 'Planlagt denne veka',
    allPlans: 'Alle planar',
    allYears: 'Alle år',
  },
  plan: {
    title: 'Planlagt',
    content: 'Planlagt innhald',
    add: 'Legg i plan',
    sharePlan: 'Knytt til gruppe',
    copySelection: 'Kopieringsval',
    copyYearPlan: 'Kopier plan',
    deleteYearPlan: 'Slett plan',
    copyYearPlanToGroup: 'Kopier ressursar',
    copyYearPlanToGroupExplanation: 'Dette vil kopiere ressursane som er delte med {groupName} i {weekNumber} til ei anna gruppe',
    chooseGroupToCopyTo: 'Vel gruppe å kopiere ressursar til',
    noPlans: 'Fann ingen planlagde ressursar i {subject} i {weekNumber}',
    goToResources: 'Gå til fagsida for {subject}',
    resourcesCopied: 'Ressursane vart kopierte til {groupName}',
  },
  yearPlan: {
    plural: 'Planar',
  },
  learningPath: {
    learningPathOverview: 'Opne oversikt over læringsløp',
    learningPathParts: '{partsCount} delar',
    noResourcesFound: 'Fann ingen ressursar i læringsløpet',
  },
  links: {
    seeAll: 'Sjå alle',
    viewTasks: 'Sjå vekas planlagde ({number})',
    viewMoreTasks: 'Tilbake til fagside',
    loadingTasks: 'Lastar vekas planlagde',
  },
  contentTypes: {
    default: 'Ressurs',
    resource: 'Ressurs',
    folder: 'Mappe',
    product: 'Produkt',
    product_container: 'Oversikt',
    product_article: 'Artikkel',
    product_package: 'Innholdspakke',
    product_header: 'Tema',
    product_tailor: 'Ressurs',
    product_part: 'Del',
    part: 'Del av læringsløp',
    product_colophon: 'Kolofon',
    article: 'Artikkel',
    learning_path: 'Læringsløp',
    document: 'Dokument',
    landing_page: 'Forside',
    cloubi_content: 'Ressurs',
    video: 'Video',
    image: 'Bilde',
    upload_video: 'Video',
    activetextbook: 'Interaktiv bok',
    drawing_tool: 'Tavleressurs',
    file: 'Fil',
    audio: 'Lyd',
    svg: 'Bilde',
    game_board: 'Spelebrett',
    game_part: 'Øva',
    form_writer: 'Innlevering',
    epub: 'E-bok',
    link: 'Lenkje',
    literary_text: 'Litterær tekst',
    peer_gynt: 'Spel',
    upload_file: 'Opplasting',
    book_reader: 'Boklesar',
    presentation: 'Presentasjon',
    flyt_task: 'Oppgåve',
    task: 'Oppgåve',
    pdf_book: 'Digitalbok',
    digitalbook: 'Digitalbok',
    game: 'Spel',
    cloubi: 'Ressurs',
    blog_post: 'Blogginnlegg',
    guide: 'Til lærer',
    model3d: '3D-modell',
    image_360: '360-bilete',
    image_collection: 'Bildesamling',
    reading_aid: 'Lesehjelper',
    colophon: 'Kolofon',
    app_article: 'Tekst',
    app_article_teacher: 'Til lærer',
    flashcard_deck: 'Flashcards',
    chatbot: 'Chatbot',
    scene: 'Scene',
    theme: 'Tema',
    conversation: 'Samtale',
  },
  sections: {
    none: 'Manglar innhald til trinna og faga dine. Prøv å endra på innstillingane.',
    teacherResources: 'Lærarressursar for {subject}, {grade}',
  },
  dialog: {
    confirm: 'OK',
    cancel: 'Avbryt',
    choose: 'Vel',
    create: 'Opprett ny',
    add: 'Legg til',
    on: 'På',
    off: 'Av',
  },
  copy: {
    copyUrl: 'Kopier lenke',
    copyTemplate: {
      title: 'Veke {weekNumber}',
    },
    messages: {
      success: 'Kopiert',
      error: 'Kunne ikkje kopiera',
    },
  },
  footer: {
    customerService: 'Kundeservice',
    whitelist: 'Kvitlisting',
    privacy: 'Personvern',
    accessibility: 'Universell utforming',
    webshop: 'Nettbutikk',
    copyright: 'Rettar',
    cookies: 'Cookies',
  },
  trial: {
    title: 'Velkommen!',
    message: 'Her finn du innhald til alle fag og alle trinn. <a href="{href}" target="_blank">Bestill ein gratis prøvelisens</a> til vårt utforskande læringsunivers. God lærelyst!',
    noHits: 'Hugs at du kan <a href="{href}" target="_blank">bestilla ein gratis prøvelisens</a> til det utforskande læringsuniverset vårt.',
  },
  license: {
    message: 'Lisensdetaljar for {name}',
    ean: 'ISBN',
    licenseModel: 'Type',
    endDate: 'Gyldig til',
    orderId: 'Ordrenr',
    usageRights: 'Antal',
    noLicenses: {
      title: 'Fann ingen lisensar',
      message: 'Om du trur dette er ein feil kan du prøva å lasta inn sida på nytt eller kontakta kundestøtte.'
    }
  },
  licenseModel: {
    OPEN: 'Open lisens',
    SCHOOL: 'Skulelisens',
    INDIVIDUAL: 'Enkeltlisens',
    PRIVATE: 'Privatlisens',
    TRIAL_SCHOOL: 'Prøvelisens, skule'
  },
  colophon: {
    title: 'Om {subject}',
    plural: 'Kolofoner',
    back: 'Tilbake til fagside',
    notFoundSubject: 'Ingen kolofonar funne for {subject} i {grade}',
    notFoundLocation: 'Ingen kolofon funne',
  },
  search: {
    title: 'Søk',
    placeholder: 'Søk her...',
    lookingFor: 'Søk innanfor {filters}...',
    globalSearch: 'Søk i heile Aunivers',
    resultsCount: '{count} treff',
    currentPage: 'Side {page} av {totalPages}',
    noResults: 'Ingen resultat funne',
    noResultsDescription: 'Fann ingen søkjeresultat som samsvarer med søkjeordet eller filtera dine.',
    spellingSuggestion: 'Meinte du',
    searchingIn: 'Søkjar i {in}',
    loadingProducts: 'Stiller inn søket',
    failed: 'Noko gjekk gale',
    reset: 'Nullstill',
    resetSearch: 'Start på nytt',
    resetFilters: 'Fjern alle filtre',
    contentTypes: 'Innhaldstypar',
    animationLabel: 'Animert illustrasjon som illustrerer eit søk',
    popularSearches: 'Populære søkjeord',
    subject: 'Søk i {subject}',
    subjectAll: 'Søk i alle {subject} ressursar',
    settings: {
      mySettings: 'Om søket',
      grade: 'Trinninnstillingar',
      results: 'Du får resultat basert på desse bøkene',
      editMessage: 'Du kan redigera trinna dine i <b>Innstillingar > Trinn og fag</b>',
    },
    lockedContent: {
      noAccess: 'Du har ikkje tilgang til dette innhaldet',
      goToWebshop: 'Gå til nettbutikken',
      relatedProduct: 'Dette innhaldet høyrer til produktet <b>{product}</b>.',
      unknownProduct: 'Dette innhaldet høyrer til eit produkt som er lisensbelagt.',
      findTeacher: 'Du finn produktet i nettbutikken vår.',
      findStudent: 'Ta kontakt med læraren din viss du forventa å ha tilgang.',
    },
    paginator: {
      page: 'Side {page}',
      nextPage: 'Neste side',
      prevPage: 'Forrige side',
      navigation: 'Sidenavigering',
    },
    filters: {
      showGradeFilter: 'Vis trinnfiltre',
      hideGradeFilter: 'Skjul trinnfiltre',
      showSubjectFilter: 'Vis fagfiltre',
      hideSubjectFilter: 'Skjul fagfiltre',
      activeFilters: 'Aktive filtre',
      removeFilter: 'Fjern {filter} som filter',
      removeAllFilters: 'Fjern alle filtre',
      filterBySubject: 'Filtrer på fag',
      allGrades: 'Alle trinn',
    },
    suggested: {
      one: 'Rettar',
      two: 'Berekraftig utvikling',
      three: 'Demokrati',
      four: 'Samfunn',
      five: 'Identitet',
    },
    sortField: {
      sorting: 'Sorteringsval',
      score: 'Mest relevant',
      modified: 'Nyleg oppdatert',
      published: 'Nyleg publisert',
    },
    checkboxes: {
      has_audio: 'Med lyd',
      has_more: 'Med opplegg',
      tiered: 'Nivådelt',
    },
    filterBoxes: {
      'target_group': 'Passar for',
      'theme': 'Tema',
      'genre': 'Sjanger',
      'series': 'Serie',
      'language': 'Språk',
      '1-4': 'Barneskule 1-4',
      '5-7': 'Barneskule 5-7',
      '8-10': 'Ungdomsskule',
      'vgs': 'Vidaregåande',
      'voksen': 'Vaksenopplæring',
      'forkurs': 'Forkurs',
      'support': 'Bok- og lydstøtte',
    },
    product: {
      back: 'Tilbake til {product}',
      placeholder: {
        Biblioteket: 'Søk i biblioteket etter tittel eller forfattar...',
        default: 'Søk her...',
      },
    },
  },
  register: {
    form: {
      title: 'Registrer ny brukar',
      intro: 'For å bruka digitale læremiddel på Aunivers.no/unibok.no må du registrera deg.',
      submit: 'Registrer',
    },
    input: {
      firstName: 'Førenamn',
      lastName: 'Etternamn',
      email: 'E-postadresse',
      password: 'Passordet ditt',
      terms: 'Eg har lese, forstått og akseptert <a href="{url}" class="underline" target="_blank">brukarvilkåra</a>'
    },
    invalid: {
      firstName: 'Førenamn er ikkje gyldig',
      lastName: 'Etternamn er ikkje gyldig',
      email: 'E-postadressa er ikkje gyldig',
      password: 'Passordet er ikkje gyldig',
    },
    error: {
      internal: 'Noko gjekk gale ved registrering av brukaren. Ver vennleg og prøv på nytt om ei lita stund.',
      loggedIn: 'Du kan ikkje registrera ein brukar når du allereie er logga inn',
      invalidInput: 'Feil ved validering av dataa dine. Sjå over og prøv på nytt',
      alreadyExists: 'Ein brukar med same e-postadresse eksisterer allereie',
      missingParams: 'Manglar nødvendig aktiveringskode',
      activate: 'Noko gjekk gale ved aktivering av kontoen din',
    },
    success: {
      title: 'Vellykka registering!',
      info: 'Brukaren din er no registrert, men må stadfestast først. Dette må du gjera no:',
      confirm1: 'Opne e-posten du har fått',
      confirm2: 'Klikk på lenkja <b>innan to dagar</b> for å aktivera brukaren din',
    },
    activate: {
      title: 'Aktivering',
      info: 'Lag eit passord til brukaren din. Oppgi minst åtte teikn, inkludert minst eitt tal.',
      inputText: 'Vis i klartekst',
      inputPassword: 'Skjul tekst',
      success: 'Passordet er lagra. Du kan no logga inn.',
    },
  },
  access: {
    title: 'Tilgang',
    public: 'Open for alle',
    teacher: 'Berre for lærer',
  },
  mimeType: {
    pdf: 'PDF-fil',
    word: 'Word-fil',
    excel: 'Regneark',
    video: 'Video',
    audio: 'Lydfil',
    image: 'Bilde',
    powerpoint: 'Presentasjon',
    archive: 'Arkiv',
    file: 'Fil',
    python: 'Python-script',
    code: 'Kode',
    text: 'Tekst',
  },
  bookreader: {
    error: 'Kunne ikkje lasta inn boklesar',
    loading: 'Laster inn boklesar',
    readBook: 'Les bok',
  },
  flashcards: {
    error: 'Kunne ikkje lasta inn flashcards',
    tip: 'Trykk på korta for å snu dei rundt.',
    start: 'Start',
    retry: 'Prøv på nytt',
    complete: 'Då var du igjennom!',
    stage: '{n} av {total}',
  },
  content: {
    published: 'Gitt ut',
    language: 'Språk',
    pageCount: 'Talet på sider',
    audio: 'Lyd',
    recordedAudio: 'Innlesen lyd',
    inSeries: 'Inngår i serie',
  },
  presentation: {
    page: 'Side',
    pageNumber: 'Side {pageNumber}',
    pageNumberOfTotal: 'Side {pageNumber} / {totalPages}',
    teacherGuide: 'Lærarrettleiing',
    menu: {
      menu: 'Meny',
      content: 'Innhald',
    },
  },
  article: {
    word: 'Ord',
    text: 'Tekst',
    toTeacher: 'Til lærer',
    toStudent: 'Rettleiing',
    teacherGuide: 'Lærarrettleiing',
    studentGuide: 'Rettleiing',
    error: 'Noko gjekk gale med å henta innhaldet. Ver vennleg og prøv igjen.',
    noContent: 'Manglar innhald ...',
    changeWidth: 'Endre breidde',
    asideOpen: 'Vis oppgåver',
    articleSub: 'Nivå {number}',
  },
  media: {
    playVideo: 'Spel av video',
    pauseVideo: 'Pause video',
    audioShort: 'Høyr',
    audioArticle: 'Høyr teksten',
    playAudio: 'Spel av lyd',
    pauseAudio: 'Pause lyd',
    closeAudio: 'Lukk',
    loadingAudio: 'Laster inn lyd',
    retryingAudio: 'Ventar på ny lydfil. Dette kan ta litt tid',
    showCopyright: 'Vis rettar',
    hideCopyright: 'skjul rettar',
    recordAudio: 'Lydopptak',
    recordingInProgress: 'Opptak pågår...',
    restartRecording: 'Start på nytt',
    startRecording: 'Spel inn lyd',
    stopRecording: 'Stopp opptak',
    pauseRecording: 'Pause opptak',
    continueRecording: 'Hald fram opptak',
    playRecording: 'Lydinnspeling klar',
    stopPlayingRecording: 'Stopp avspeling',
    saveRecording: 'Legg til innlevering',
    removeRecording: 'Slett innspeling',
    errorRecording: 'Noko gjekk gale med lydopptaket',
    missingPlayer: 'Mangler lydavspiller',
    recordingMaxLength: 'Maks {minutes} min opptak',
    errorNotAllowed: 'Du har ikkje tilgang til ressursen',
    errorNotFound: 'Ressursen er tom eller ikkje tilgjengeleg',
    updateFilename: 'Endre namn',
    missingFilename: 'Tomt filnamn',
    filenamePlaceholder: 'Skriv eit namn...',
    editFileName: 'Rediger namn',
    fileIsTooLargeTitle: 'For stor fil',
    fileIsTooLargeText: 'Maksgrensa på {mb}MB er nådd. Kan du velje ei mindre fil?',
    unknownError: 'Ukjend feil har oppstått',
    loading: 'Lastar...',
    uploadFile: 'Last opp fil',
    downloadError: 'Ukjend feil ved nedlastinga',
    uploadImage: 'Last opp bilete',
    uploading: 'Laster opp...',
    download: 'Last ned',
    downloadFile: 'Last ned {mimeType}',
    removeFile: 'Slett fil',
    uploadReady: '{fileType} lasta opp',
    changeSpeed: 'Endre hastigheit',
    normalSpeed: 'Vanlig',
    nameFile: 'Gi fila eit namn',
    editName: 'Rediger namn',
    writeNote: 'Skriv eit notat...',
  },
  recordError: {
    aborted: 'Opptak avbrote',
    notAllowed: 'Ingen løyve til å ta opp lyd',
    notFound: 'Fann ingen lydopptakseining',
    notReadable: 'Kan ikkje lese frå lydopptakseininga',
    notSupported: 'For å ta opp lyd, bruk nettlesarar som Chrome og Firefox',
    security: 'Det oppstod ein tryggingsfeil ved tilgang til lydopptakseininga',
    type: 'Ugyldig type lydopptakseining',
    state: 'Lydopptakseininga er i ein ugyldig tilstand',
    unknown: 'Det oppstod ein ukjend feil',
  },
  lottie: {
    play: 'Spel av animasjon',
    pause: 'Pause animasjon',
  },
  licenseControl: {
    message: {
      title: 'Du har ikkje tilgang til dette innhaldet',
      body: {
        teacher: 'Me klarte ikkje å finna ein gyldig lisens på dette innhaldet. Om du meiner dette er ein feil, kontakt kundestøtte for hjelp.',
        student: 'Spør læraren din om hjelp',
      },
      product: {
        library: '<b>Biblioteket</b> er fullt av digitale bøker, skapt for å gi lesekompetanse og leseglede gjennom heile grunnskulen. Du finn bøker med innlesen lyd, bøker på engelsk og populære seriar.',
        paperPlus: '<b>Papir+</b> gir deg ei mengd elevark med sjølvforklarande oppgåver i ei rekkje fag på 1.-7. trinn. Skriv ut og ta med rett inn i timen.',
        exam: '<b>Terminprøvane</b> kjem kvar haust og vår i norsk, matematikk og engelsk for ungdomstrinnet. Her får du komplette løysingsforslag og prøvar, i tillegg til støttemateriell. Du får høve til å tilpassa, endra og differensiera oppgåvene slik at elevane dine får ein unik prøve.',
      },
      upgrade: {
        noSubscription: 'Du kan bestilla prøvelisens.',
        trial: 'Du har prøvelisens. Lisens kan kjøpast i nettbutikken.',
        why: 'Abonnementet må oppgraderast for å få tilgang til Biblioteket/Papir+/Terminprøvar.',
        who: 'Snakk med skuleleiaren din om å oppgradera abonnementet skulen din har på Aunivers.',
      },
    },
    buttons: {
      back: 'Tilbake',
      webshop: 'Til nettbutikk',
      trial: 'Prøvelisens',
    },
  },
  fullscreen: {
    close: 'Lukk fullskjerm',
    open: 'Åpne fullskjerm',
  },
  pdfViewer: {
    downloadDisabled: 'Beklagar, men du kan ikkje lagre denne PDFen.',
  },
  labels: {
    product_article: 'Produktartikkel',
    learning_path: 'Læringsløp',
    file: 'Fil',
    product_part: 'Del av løp',
    video: 'Video',
    article: 'Artikkel',
    task: 'Oppgåve',
    resource: 'Ressurs',
    digitalbook: 'Digitalbok',
    audio: 'Lyd',
    audio_transcription: 'Tekst',
    part: 'Del av løp',
    game: 'Spill',
    document: 'Dokument',
    documents: 'Dokument',
    book_reader: 'Bokleser',
    presentation: 'Presentasjon',
    other: 'Anna',
    app_teacher: 'Lærerveiledning',
    podcast: 'Podkast',
    essay: 'Fagtekst',
    activity: 'Aktivitet',
    map: 'Kart',
    print: 'Utskrift',
    fiction: 'Skjønnlitterær tekst',
    poem: 'Dikt',
    short: 'Novelle',
    experiment: 'Forsøk',
    pause: 'Avbrekk',
    text: 'Tekst',
    wimmelimage: 'Myldrebilde',
    teacher: 'Lærerveiledning',
    theme: 'Tema',
    package: 'Innhaldspakke',
    recommended: 'Tilrådd',
    product: 'Produkt',
    chatbot: 'Chatbot',
    flashcards: 'Flashcards',
    subject_matter: 'Fagstoff',
    model_text: 'Modelltekst',
    summary: 'Samandrag',
    grammar: 'Grammatikk',
    dialog: 'Dialog',
    scene: 'Scene',
    manipulatives: 'Konkretar',
    canvas: 'Lerret',
    teacher_guide: 'Lærerveiledning',
    text_comprehension: 'Tekstforståing',
    assignment: 'Innlevering',
    form_writer: 'Skriveramme',
    chapter: 'Kapittel',
  },
  activities: {
    'messages': {
      title: 'Aktivitetar',
    },
    'bokstavoppdrag': 'Bokstavoppdrag',
    'bruke begrepene': 'Bruke omgrepa',
    'diskutere': 'Diskutere',
    'forsøk': 'Forsøk',
    'gloser': 'Gloser',
    'gruble sammen': 'Gruble saman',
    'huskesetning': 'Huskesetning',
    'interaktiv oppgave': 'Interaktiv oppgåve',
    'ki-oppgave': 'KI-oppgåve',
    'kladdebokoppgave': 'Kladdebokoppgåve',
    'kulturkunnskap': 'Kulturkunnskap',
    'lage': 'Laga',
    'leke': 'Leike',
    'lese': 'Lese',
    'leseforståelse': 'leseforståing',
    'leseoppdrag': 'Leseoppdrag',
    'lyd': 'Lyd',
    'lytte': 'Lytte',
    'lyttetekst': 'Lyttetekst',
    'lære': 'Lære',
    'nøkkelord': 'Nøkkelord',
    'presentere': 'Presentera',
    'reflektere': 'Reflektera',
    'regne': 'Rekna',
    'sammendrag': 'Samandrag',
    'samtale': 'Samtale',
    'skrive': 'Skrive',
    'skriveoppgave': 'Skriveoppgåve',
    'skriveramme': 'Skriveramme',
    'skrivestarter': 'Skrivestartar',
    'snakke': 'Snakke',
    'spill': 'Spel',
    'synge': 'Syngje',
    'tankekart': 'Tankekart',
    'tematekst': 'Tematekst',
    'utforske': 'Utforske',
    'utskrift': 'Utskrift',
    'uttale': 'Uttale',
    'venndiagram': 'Venndiagram',
    'vgs': 'Vgs',
    'video': 'Video',
    'vurdering': 'Vurdering',
    'øve': 'Øve',
  },
  genre: {
    'romanutdrag': 'Romanutdrag',
    'fortelling': 'Forteljing',
    'novelle': 'Novelle',
    'eventyr': 'Eventyr',
    'fantasy': 'Fantasy',
    'dikt': 'Dikt',
    'sangtekst': 'Songtekst',
    'fagartikkel': 'Fagartikkel',
    'saktekst': 'Saktekst',
    'debattinnlegg': 'Debattinnlegg',
    'nyhetsartikkel': 'Nyheitsartikkel',
    'reklame': 'Reklame',
    'some-innlegg': 'SoMe-innlegg',
    'tale': 'Tale',
    'appell': 'Appell',
    'roman': 'Roman',
    'lesetrening': 'Lesetrening',
    'detektiver og mysterier': 'Detektivar og mysterium',
    'leserinnlegg': 'Lesarinnlegg',
    'vitser': 'Vitsar',
    'krim': 'Krim',
    'science fiction': 'Science fiction',
    'humor': 'Humor',
    'lettlest': 'Lettlest',
    'spenning': 'Spenning',
    'sakprosa': 'Sakprosa',
  },
  copyright: {
    open: 'Opne bildebeskrivelse',
    close: 'Lukk bildebeskrivelse',
    image: 'Bilde: {copyright}',
    animation: 'Animasjon: {copyright}',
  },
  embeds: {
    notSupported: 'Innebygd media er ikkje støtta'
  },
  feedback: {
    question: 'Fann du det du leita etter?',
    positive: 'Tusen takk!',
    negative: 'Vi set stor pris på tilbakemelding! Send gjerne ein e-post til <a href="mailto:{email}" class="font-bold underline">{email}</a>. Hugs å inkludera ein kopi av adresselinja.',
    copyUrl: 'Kopier adresselinja',
    send: 'Send inn',
    event: {
      rated: 'Takk!',
      submit: 'Takk for tilbakemeldinga!',
      copied: 'Adresselinja vart kopiert',
      copyFailed: 'Kunne ikkje kopiera adresselinja',
    }
  },
  vidstack: {
    'Caption Styles': 'Tekststilar',
    'Captions look like this': 'Teksting ser slik ut',
    'Closed-Captions Off': 'Teksting av',
    'Closed-Captions On': 'Teksting på',
    'Display Background': 'Vis bakgrunn',
    'Enter Fullscreen': 'Gå til fullskjerm',
    'Enter PiP': 'Gå til bilete i bilete',
    'Exit Fullscreen': 'Avslutt fullskjerm',
    'Exit PiP': 'Avslutt bilete i bilete',
    'Google Cast': 'Google Cast',
    'Keyboard Animations': 'Tastaturanimasjonar',
    'Seek Backward': 'Spol tilbake',
    'Seek Forward': 'Spol framover',
    'Skip To Live': 'Hopp til direktesending',
    'Text Background': 'Tekstbakgrunn',
    'Accessibility': 'Tilgjengelegheit',
    'AirPlay': 'AirPlay',
    'Announcements': 'Kunngjeringar',
    'Audio': 'Lyd',
    'Auto': 'Auto',
    'Boost': 'Forsterk',
    'Captions': 'Teksting',
    'Chapters': 'Kapittel',
    'Color': 'Farge',
    'Connected': 'Tilkopla',
    'Connecting': 'Koplar til',
    'Continue': 'Fortsett',
    'Default': 'Standard',
    'Disabled': 'Deaktivert',
    'Disconnected': 'Fråkopla',
    'Download': 'Last ned',
    'Family': 'Familie',
    'Font': 'Skrift',
    'Fullscreen': 'Fullskjerm',
    'LIVE': 'DIREKTE',
    'Loop': 'Gjenta',
    'Mute': 'Demp',
    'Normal': 'Normal',
    'Off': 'Av',
    'Opacity': 'Gjennomsiktigheit',
    'Pause': 'Pause',
    'PiP': 'Bilete i bilete',
    'Play': 'Spel av',
    'Playback': 'Avspeling',
    'Quality': 'Kvalitet',
    'Replay': 'Spel igjen',
    'Reset': 'Tilbakestill',
    'Seek': 'Søk',
    'Settings': 'Innstillingar',
    'Shadow': 'Skugge',
    'Size': 'Storleik',
    'Speed': 'Fart',
    'Text': 'Tekst',
    'Track': 'Spor',
    'Unmute': 'Slå på lyd',
    'Volume': 'Volum',
  },
  subscription: {
    messages: {
      endDate: 'Lisensen på {name} går ut {date}',
      missing: 'Ingen abonnement',
      current: 'Du har følgjande aktive abonnement:',
      upgrade: {
        fromBasic: 'Ved å oppgradera til PLUSS får heile skulen tilgang til Papir+ og Biblioteket.',
        fromPlus: '',
      },
      webshop: {
        internal: '<a href="https://skole.aschehoug.no" class="underline focus-visible:ring" target="_blank">skole.aschehoug.no</a>',
        external: '<a href="https://www.pendel.no/" class="underline focus-visible:ring" target="_blank">Pendel</a> eller <a href="https://skolon.no" class="underline focus-visible:ring" target="_blank">Skolon</a>',
      },
      readMore: 'Les meir om, og endre abonnementet her:',
    },
    application: 'Aunivers',
    name: {
      PrimaryTrial: 'Aunivers 1–7 Prøvelisens',
      PrimaryBasic: 'Aunivers 1–7 Basis',
      PrimaryIndividual: 'Aunivers 1–7 Individuell',
      PrimaryPlus: 'Aunivers 1–7 Pluss',
      PrimaryPremium: 'Aunivers 1–7 Premium',
      SecondaryTrial: 'Aunivers 8–10 Prøvelisens',
      SecondaryBasic: 'Aunivers 8–10 Basis',
      SecondaryIndividual: 'Aunivers 8–10 Individuell',
      SecondaryPlus: 'Aunivers 8–10 Pluss',
      SecondaryPremium: 'Aunivers 8–10 Premium',
      VgsTrial: 'Aunivers VGS Prøvelisens',
      VgsIndividual: 'Aunivers VGS Individuell',
    },
    type: {
      none: 'Ingen',
      trial: 'Prøve',
      individual: 'Individuell',
      basic: 'Basis',
      plus: 'Pluss',
      premium: 'Premium',
    }
  },
  validation: {
    general: {
      required: {
        error: 'Feltet må fyllast ut',
      },
    },
    favorite: {
      name: {
        error: 'Namnefeltet kan berre innehalda teikn: a til å, 0 til 9 og utvalde spesialteikn: {\'.\'}{\',\'}{\'@\'}{\'!\'}{\'?\'}{\'|\'}{\'§\'}{\'#\'}{\'<\'}{\'>\'}{\'[\'}{\']\'}{\'-\'}{\'+\'}{\'*\'}{\'"\'}{\'^\'}{\'`\'}{\':\'}{\';\'}',
      },
      note: {
        error: 'Notatfeltet kan berre innehalda teikn: a til �, 0 til 9 og utvalde spesialteikn: {\'.\'}{\',\'}{\'@\'}{\'!\'}{\'?\'}{\'|\'}{\'§\'}{\'#\'}{\'<\'}{\'>\'}{\'[\'}{\']\'}{\'-\'}{\'+\'}{\'*\'}{\'"\'}{\'^\'}{\'`\'}{\':\'}{\';\'}',
      },
    },
  },
  flyt: {
    missingTranslationMessage: 'Vi arbeider med å få vist oppgåvene våre på nynorsk!',
  },
  chatbot: {
    remember: 'Botten hugsar berre meldingane under',
    placeholder: 'Skriv her ...',
    answering: 'Chatbotten svarar',
    answered: 'Chatbotten har svart',
    answer: 'Svar frå chatbotten',
    message: 'Meldinga di',
    error: 'Noko gjekk gale, ver vennleg og prøv igjen',
    mathFormula: 'Set inn formel',
    info: {
      title: 'Du snakkar no med ein chatbot',
      heading: 'KI-oppgåve i Aunivers',
      paragraph1: 'Dette er ei oppgåve som bruker kunstig intelligens (KI) for å hjelpa deg med å forstå og bruka fagstoff betre. Verktøyet gir deg hjelp og rettleiing, men løyser ikkje oppgåvene for deg.',
      paragraph2: 'Læraren din kan ikkje sjå kva du skriv eller gjer når du bruker dette verktøyet. Ingen av samtalane dine blir lagra.',
      paragraph3: 'Ettersom det er KI, kan det henda at den seier noko som er feil. Om du er i tvil, kan du sjekka med andre kjelder.',
    },
    feedback: {
      title: 'Rapporter feil i chatbot',
      cta: 'Rapporter feil',
      message: 'Gjorde bota noko rart? Trykk på knappen for å senda inn loggen til oss, så hjelper du oss å gjera den betre.',
      disclaimer: 'Innsendinga er anonymisert.',
    },
  },
  assign: {
    share: 'Del',
    close: 'Steng',
    delete: 'Slett',
    shareWithStudents: 'Del med elevar',
    goToExam: 'Gå til prøva',
    openTheExam: 'Opne prøva',
    openingExam: 'Opnar prøva ...',
    closeTheExam: 'Steng prøva',
    closeForAll: 'Steng prøva for alle',
    closingExam: 'Stenger prøva ...',
    examClosed: 'Prøva er stengd',
    deleteExam: 'Slett prøva',
    deletingExam: 'Sletter prøva ...',
    deleteConfirm: 'Er du heilt sikker på at du vil sletta terminprøva: {name}?',
    locked: 'Låst',
    shared: 'Åpen',
    opened: 'Opna',
    closed: 'Stengd',
    editAccess: 'Rediger elevtilgang',
    noStudents: 'Fann ingen elevar. Sørg for at du har skrive rett namn.',
    noStudentsInGroup: 'Fant ingen elever i gruppen',
    chooseAll: 'Vel alle',
    chooseGroup: 'Vel gruppe',
    chooseStudents: 'Vel elevar',
    chooseStudentsAccess: 'Vel kva elevar som skal få tilgang til terminprøva.',
    studentsAccessInfo: 'Elevane må ha logga inn i Aunivers tidlegare for å bli viste i lista.',
    searchPlaceholder: 'Søk blant elevane ...',
    startExam: 'Start prøva no',
    startingExam: 'Starter prøva ...',
    open: 'Opne',
    closeExam: 'Steng prøva',
    createExam: 'Opprett prøve',
    creatingExam: 'Opprettar prøve ...',
    saveStudents: 'Lagre elevval',
    savingStudents: 'Lagrar elevval ...',
    createError: 'Noko gjekk gale med å oppretta prøva, ver vennleg og prøv igjen eller kontakt kundeservice.',
    createInfo1: 'Du må oppretta prøva før du kan dela ho med dei elevane du ønskjer i vald gruppe.',
    createInfo2: 'Frykt ikkje, du kan trygt oppretta prøva utan at ho blir delt med elevane dine.',
    taskIsOpen: 'Terminprøva er open',
    taskIsClosed: 'Terminprøva er låst',
    taskStatusInfo: 'For at eleven skal få tilgang til terminprøva må prøva og statusen til eleven vera sett til open.',
    error: 'Noko gjekk gale.',
    planned: 'Planlagde prøvar',
    noTasks: 'Du har ikkje oppretta nokon terminprøvar',
    noTasksInfo1: 'Når du har oppretta ei prøve, kan du dela ho med elevar.',
    noTasksInfo2: 'Sørg for at læraren som skal dela prøva med elevane på prøvedagen, er medlem i gruppa.',
    confirm: 'Bekreft val',
    confirmInfo: 'Er du sikker på at du vil {status} prøva for {student}?',
    confirmClose: 'Steng',
    searchForStudents: 'Søk etter elevar',
    searchForStudentsTip: 'Søkjeordet må ha minst 3 teikn',
    missingStudents: 'Manglar det nokon elevar?',
    searchSchoolPlaceholder: 'Søk blant elevane på skulen ...',
    studentAdded: 'Lagt til',
    addStudents: 'Legg til elevar',
    closedFor: 'Prøva er <b>stengd</b> for:',
    openFor: 'Prøva er <b>open</b> for:',
    seeExam: 'Sjå prøva',
    seeAndCreate: 'Sjå og opprett',
    seeAndEdit: 'Sjå, tilpass og opprett',
    tasks: 'Oppgåver',
    chooseTask: 'Vel denne oppgåva',
    taskChosen: 'Oppgåve vald',
    toasts: {
      createSuccess: 'Prøva er oppretta',
      createError: 'Noko gjekk gale med å oppretta prøva',
      deleteSuccess: 'Prøva ble sletta',
      deleteError: 'Noko gjekk gale med å sletta prøva',
      openSuccess: 'Prøva vart opna',
      openError: 'Noko gjekk gale med å opna prøva',
      closeSuccess: 'Prøva vart stengd',
      closeError: 'Noko gjekk gale med å stengja prøva',
      saveSuccess: 'Prøva vart lagra',
      saveError: 'Noko gjekk gale med å lagra prøva',
      addUsersAndOpenSuccess: 'Terminprøva vart opna og delt med elevane',
      addUsersAndOpenError: 'Noko gjekk gale med å opna terminprøva og dela med elevane',
      updateUserSuccess: 'Prøva vart {status} for {user}',
      updateUserError: 'Noko gjekk gale med å endra status for {user}',
    },
    student: {
      infoTitle: 'Akkurat no har du ingen tildelte terminprøvar',
      infoMessage: 'Når læraren din deler ei terminprøve med deg, vil ho dukka opp her!',
      noTasksFound: 'Fant ingen oppgåver'
    },
    upcoming: {
      autumnTitle: 'Haustens terminprøvar',
      springTitle: 'Vårens terminprøvar',
      unknownDate: 'Terminprøvene er ikkje tilgjengelege.',
    },
    placeholders: {
      chooseGroup: 'Vel gruppe',
      chooseSchoolYear: 'Vel skuleår',
      chooseGrade: 'Vel trinn',
      chooseSubject: 'Vel fag',
    },
  },
  termExam: {
    title: 'Terminprøve',
    byline: 'Terminprøve { title }',
    group: 'Gruppe: <b>{ groupName }</b>',
    earlier: 'Tidlegare prøvar',
    earlierDescription: 'Her finn du tidlegare terminprøvar som elevane kan bruke til å øve. Desse har ikkje same funksjonalitet som dei aktive terminprøvane. Dei kan ikkje tildelast og er ikkje sjølvrettande.',
    others: 'Innhald',
    missing: 'Ingen oppgåver tilgjengelege',
  },
  report: {
    title: 'Rapportar',
    button: 'Rapport',
    submissions: 'Innleveringar',
    result: 'Resultat',
    errorLoadingData: 'Noko gjekk gale med å henta rapportdata, prøv igjen',
    exam: {
      title: 'Terminprøver',
      tooltip: {
        open: 'Her finn du rapportar for terminprøvene',
        close: 'Tilbake til prøvene',
      },
      noResults: {
        title: 'Ingen resultat',
        message: 'Har du valt rett gruppe og trinn?',
      }
    },
    banner: {
      title: 'Rapport',
      description: 'Terminprøve vår 2025',
      responseRate: 'Svarprosent: ',
      total: 'Totalresultat',
      group: 'Gruppe: ',
    },
    toolbar: {
      missing: 'Ver vennleg og vel:',
      groupDropdown: 'Gruppe',
      subjectDropdown: 'Fag',
      gradeDropdown: 'Trinn',
      weekDropdown: 'Veke',
      contextDropdown: 'Tema',
      gradeTypeDropdown: 'Skuleslag',
      intervalDropdown: 'Intervall',
    },
    interval: {
      '1w': 'Ei veke',
      '3m': 'Tre mnd.',
      '6m': 'Seks mnd.',
      'start': 'Skulestart'
    },
    status: {
      correct: 'riktig',
      wrong: 'feil',
      unanswered: 'ubesvart',
    },
    studentList: {
      name: 'Namn',
      result: 'Resultat',
    },
    messages: {
      notStarted: 'Ikkje påbegynt',
      toAnswer: 'Gå til svar',
      baseFilter: 'Juster filter for å sjå rapport',
      error: {
        title: 'Noko gjekk gale',
        message: 'Her gjekk noko gale. Prøv igjen seinare.',
      },
      missingFilters: {
        title: 'Vel gruppe og trinn',
        message: 'Både gruppe og trinn må vera valt',
      },
      missingGroup: {
        title: 'Vel gruppe',
        message: 'Vel ei gruppe for å sjå rapportar',
      },
      noResults: 'Ingen resultat funne',
    },
    season: {
      spring: 'vår',
      autumn: 'haust',
    },
    actions: {
      goToFormWriter: 'Gå til innleveringsramma',
      goToFlytTask: 'Gå til oppgåva',
    },
  },
  sources: {
    showSources: 'Vis kjelder',
    sources: 'Kjelder',
  },
  reportFeedback: {
    button: 'Gi tilbakemelding',
    placeholder: '// Skriv tilbakemeldinga di her',
    subject: 'Tilbakemelding: {title}',
    url: 'Tilbakemeldinga gjeld innhaldet på {url}',
    intro: 'Til redaksjonen i Aschehoug,',
    organization: 'Eg tilhøyrer {name} ({number}).'
  },
  model3d: {
    touch: 'Touch',
    mouse: 'Mus',
    keyboard: 'Tastatur',
    touchRotate: 'Ein finger for å rotera.',
    touchMove: 'To fingrar for å flytte.',
    touchZoom: 'Klyp for å zooma.',
    mouseRotate: 'Hold inne venstre museknapp for å rotera.',
    mouseMove: 'Hold inne høgre museknapp for å flytta.',
    mouseZoom: 'Scroll hjulet på musa for å zooma.',
    keyboardRotate: 'Piltastar for å rotera.',
    keyboardMove: 'Alt (Windows) / Option (Mac) + piltaster for å flytta.',
    keyboardZoom: '+ for å zooma inn og − for å zooma ut.',
  },
  scene: {
    reset: 'Slett alt i scena',
    resetConfirm: 'Bekreft',
    resetText: 'Dette vil nullstilla scena til sånn den opphavleg var.',
    delete: 'Slett',
    dragDelete: 'Dra hit for å sletta',
    clone: 'Klon',
    keyboard: 'Tastatur',
    keyboardMove: 'Piltaster for å flytta.',
    keyboardResize: '+ for å forstørra og - for å forminska.',
    keyboardRotate: 'J og K for å rotera.',
    settings: 'Instillinger',
    showMeasurements: 'Vis mål',
  },
  share: {
    title: 'Del',
    edit: 'Rediger tildeling',
    list: 'Liste',
    viewAll: 'Sjå alle',
    placeholders: {
      messageField: 'Skriv her...',
    },
    options: {
      now: 'Del no',
      time: 'Velg tidspunkt',
      homework: 'Lekse',
    },
    messages: {
      share: 'Del',
      shareList: 'Del lista',
      shareResource: 'Del ressursen',
      sharing: 'Deler',
      edit: 'Rediger',
      save: 'Lagre',
      saving: 'Lagrer...',
      optionalMessage: 'Valfri melding',
      resource: 'Ressurs',
      list: 'Liste',
      homework: 'Marker som lekse',
      recent: 'Siste frå lærer',
      future: 'Valt tidspunkt må vere i framtida',
    },
    toasts: {
      createError: 'Kunne ikkje dela',
      createSuccess: 'Innhald delt'
    },
    teacher: {
      short: 'Kun synleg for lærarar',
      title: 'Elevar vil ikkje sjå lærarinnhald',
      message: 'Ressursen du ønskjer å dela er kun synleg for lærar. Elevar du deler ressursen med vil ikkje sjå han.',
      list: 'Ressursen er kun synleg for lærarar. Elevar du deler lista med vil ikkje sjå denne ressursen.',
    },
  },
  shared: {
    week: 'Veke {weekNumber}',
    empty: 'Her var det tomt!',
    goToList: 'Gå til liste',
    goToResource: 'Gå til ressurs',
    list: 'Liste',
    message: 'Melding:',
    noMessage: 'Ingen melding',
    sharedWith: 'Delt med',
    deleteShared: 'Slett tildeling',
    latestFromTeacher: 'Siste frå lærer',
    allFromTeacher: 'Alt frå lærer',
    toasts: {
      updated: 'Tildelingen vart oppdaterte'
    },
    students: '{n} elev | {n} elevar',
    teachers: '{n} lærer | {n} lærarar',
  },
  myContent: {
    title: 'Mitt innhald',
    lists: 'Mine listar',
    shared: 'Delt av meg',
    reports: 'Rapportar og innleveringar',
    studentTitle: 'Frå lærer',
    studentDescription: 'Her ser du innhald som læraren har delt med deg',
  },
  formWriter: {
    error: 'Noko gjekk gale med å henta skjemaet, ver vennleg og prøv igjen.',
    uploadImage: 'Last opp eit bilete',
    imageTeacher: 'Her kan elevane leggja til eit bilete',
    uploadingImage: 'Lastar opp bilete ...',
    deleteImage: 'Slett bilete',
    downloadImage: 'Last ned bilete',
    uploadFile: 'Last opp fil',
    chooseImage: 'Vel eit bilete frå lista til høgre',
    chooseOrUploadImage: 'Vel eit bilete frå lista til høgre, eller last opp eit bilete her:',
    submit: 'Send til lærar',
    downloadWord: 'Last ned Word-dokument',
    downloadPdf: 'Last ned PDF',
    delivered: 'Innleveringar',
    delete: 'Slett',
    download: 'Last ned',
    downloading: 'Lastar ned ...',
    fileTeacher: 'Fila eleven har levert:',
    fileStudent: 'Fila du har levert til læraren din:',
    uploading: 'Laster opp...',
    upload: 'Last opp',
    loading: 'Laster...',
    confirmLeave: 'Skjemaet har endringar som ikkje er lagra. Er du sikker?',
    saveReminder1: 'Hugs å senda innhaldet til læraren.',
    saveReminder2: 'Hugs å senda innhaldet til læraren på nytt.',
    saveConfirmation: 'Innhaldet er sendt til læraren.',
    draft: 'Utkast',
    wordCount: '{count} ord',
    wordLimitReached: 'Maksgrensa på {max} ord nådd',
    tooltips: {
      label: 'Vis/skjul etikett',
      description: 'Vis/skjul hjelpetekst',
      placeholder: 'Vis/skjul plasshaldar',
      modelText: 'Vis/skjul modelltekst',
      image: 'Last opp eit bilete',
      print: 'Skriv ut',
      download: 'Nedlastingsval',
      chooseImage: 'Vel bilete',
    },
    labels: {
      group: 'Klasse/gruppe',
      visited: 'Besøkt ({number})',
      notVisited: 'Ikkje besøkt ({number})',
      chooseStudent: 'Vel elev',
      noStudents: 'Ingen elevar',
      showStudents: 'Vis elevar',
      chooseVersion: 'Vel versjon',
      noVersions: 'Ingen versjonar',
    },
    toasts: {
      submit: 'Innhaldet vart levert!',
      submitError: 'Noko gjekk gale med å levera teksten, ver vennleg og prøv igjen.',
      fileDownloadError: 'Noko gjekk gale med å lasta ned fila. Ver vennleg og prøv igjen',
      fileDownloadSuccess: 'Fila vart lasta ned',
      nothingToExport: 'Ingenting å eksportera',
      imageUpload: 'Biletet vart lasta opp!',
      imageUploadError: 'Noko gjekk gale med å lasta opp biletet, ver vennleg og prøv igjen',
      missingRecordingError: 'Opptaket er tomt eller ikkje tilgjengeleg',
      missingFileError: 'Ressursen er tom eller ikkje tilgjengeleg',
    },
    callouts: {
      missingMethods: 'Ingen innleveringsmetodar tilgjengelege endå',
      missingAssignment: 'Innhaldet ditt i felta nedanfor er berre synleg for deg',
      versionLimitReached: 'Maksgrensa på 100 versjonar per innlevering er nådd',
      missingGroups: 'For å sjå innhald frå elevane må du vera knytt til ei eller fleire grupper.',
      viewingPreviousVersion: 'Du ser på ein tidlegare versjon. Du kan ikkje redigera innhald eller senda inn når du ser på tidlegare versjonar.',
    },
    placeholders: {
      imageUpload: 'Her kan eleven lasta opp eit bilete',
      audioRecording: 'Her kan eleven spela inn eit lydopptak',
      fileUpload: 'Her kan eleven lasta opp ei fil',
    },
  },
  tts: {
    voice: 'KI-stemme',
    warning: 'Stemma som les denne artikkelen er laga ved hjelp av kunstig intelligens (KI)',
    missingText: 'Ingen tekst funnen',
    generateError: 'Feil ved avspeling. Prøv igjen seinare.',
  },
  reports: {
    activities: 'Aktivitetar',
    noAssignmentData: 'Ingen oppgåvedata tilgjengeleg',
    formwriter: {
      delivered: 'Levert',
      inProgress: 'Påbegynt',
      notDelivered: 'Ikkje levert',
      student: 'Elev',
      activity: 'Aktivitet',
      name: 'Namn',
      status: 'Status',
      lastActivity: 'Siste aktivitet',
    },
    filters: {
      all: 'Alle',
      completed: 'Fullført',
      started: 'Påbegynt',
      notStarted: 'Ikkje påbegynt',
    },
    breadcrumb: {
      aria: 'Rapportnavigasjon',
      main: 'Aktiviteter',
      sep: ' / ',
      activityFallback: 'Aktivitet',
    },
    details: {
      activityDetails: 'Aktivitetsdetaljar',
      taskDetails: 'Oppgåvedetaljar',
      timestamp: 'Tidsstempel',
      duration: 'Varigheit',
      score: 'Poengsum',
      user: 'Brukar',
      taskResults: 'Oppgåveresultat',
      taskItem: 'Oppgåve',
      submittedAt: 'Levert',
      studentInfo: 'Elevinfo',
      name: 'Namn',
      totalScore: 'Total poengsum',
      individualResults: 'Individuelle resultat',
      taskInfo: 'Oppgåveinformasjon',
      title: 'Tittel',
    },
    status: {
      correct: 'Riktig',
      partiallyCorrect: 'Delvis riktig',
      incorrect: 'Feil',
      notSubmitted: 'Ikkje levert',
      notStarted: 'Ikkje påbegynt',
      started: 'Påbegynt',
      completed: 'Fullført',
      partiallyCompleted: 'Delvis fullført',
      passed: 'Bestått',
      failed: 'Ikkje bestått',
      partiallyPassed: 'Delvis bestått',
      noData: 'Ingen data',
      unknown: 'Ukjent status',
      notParticipated: 'Ikkje deltatt',
      notCompleted: 'Ikkje fullført',
    },
    state: {
      retry: 'Prøv igjen',
      loading: 'Laster',
      error: {
        load: {
          title: 'Noe gikk galt',
          message: 'Vi klarte ikke å hente rapportdataene. Vennligst prøv igjen senere.',
        },
        empty: {
          title: 'Ingen rapportdata',
          message: 'Det finnes ingen rapportdata for de valgte filtrene. Prøv med andre filtre.',
        }
      }
    },
    result: {
      single: 'resultat',
      plural: 'resultat',
    },
    titles: {
      activity: 'Aktivitet',
    },
    pagination: {
      title: 'Paginering',
      page: 'Side',
      previous: 'Forrige',
      next: 'Neste',
    },
    sort: {
      aToZ: 'A–Z',
      zToA: 'Z–A',
      oldest: 'Eldst',
      newest: 'Nyest',
      sortMode: 'Sorteringsmodus',
      viewMode: 'Visningsmodus',
      pagination: 'Paginering',
      list: 'Liste',
      grid: 'Rutenett',
      title: 'Sortering',
      byTime: 'Sorter på tid',
      newestFirst: 'Nyaste fyrst',
      oldestFirst: 'Eldste fyrst',
    },
    sidebar: {
      ariaLabel: 'Filter for rapporter',
      title: 'Filter',
      group: 'Gruppe',
      subject: 'Fag',
      gradeType: 'Skoleslag',
      user: 'Bruker',
      type: 'Type',
      period: 'Periode',
      allSubjects: 'Alle fag',
      allTypes: 'Alle typer',
      allPeriods: 'Alle periodar',
      allGradeTypes: 'Alle skoleslag',
      all: 'Alle',
      sections: {
        groupUser: 'Gruppe og bruker',
        content: 'Innhold',
        school: 'Skole',
      },
    },
    types: {
      activity: 'Aktivitet',
      task: 'Oppgave',
      assignment: 'Innlevering',
    },
    statusFilters: {
      all: 'Alle',
      completed: 'Fullført',
      started: 'Påbegynt',
      notStarted: 'Ikkje påbegynt',
    },
    metrics: {
      completion: 'Gjennomføring',
      understanding: 'Forståelse',
      engagement: 'Engasjement',
      assignments: 'Innleveringar:',
      tasks: 'Riktige oppgåver:',
      visits: 'Besøk:',
      completedTasksAndAssignments: 'Fullførte oppgåver og innleveringar',
      visitedArticle: 'Besøkt artikkel',
    },
    periods: {
      schoolYear: 'Skoleår',
      autumn: 'Høstsemester',
      spring: 'Vårsemester',
      last30: 'Siste 30 dagar',
      last7: 'Siste 7 dagar',
      today: 'I dag',
    },
    tabs: {
      overview: 'Oversikt',
      activities: 'Aktiviteter',
      visits: 'Besøk',
      task: 'Oppgåve',
      assignment: 'Innlevering',
    },
    viewModes: {
      rows: 'Rader',
      table: 'Tabell',
    },
    overview: {
      completedTasks: 'Fullførte oppgaver',
      needsAssistance: 'Trenger hjelp',
      noActivity: 'Ingen aktivitet',
      timeSpent: 'Tidsbruk',
      timeSpentAverage: 'Average time: 30m 47s'
    },
    table: {
      headers: {
        name: 'Namn',
        progression: 'Progresjon',
        lastVisited: 'Sist besøkt'
      },
      scrollHint: 'Rull sidelengs for å sjå alle oppgåver'
    },
    labels: {
      visited: 'Besøkt ({number})',
      visitCount: 'Besøkt: {visited} av {total}',
      visitedAt: 'Besøkt: {timestamp}',
      visitStatus: 'Besøkt:',
      visitedTitle: 'Besøkt',
      notVisitedTitle: 'Ikkje besøkt'
    },
    content: {
      meta: {
        type: 'Type',
        published: 'Publisert',
        parent: 'Forelder',
        grades: 'Trinn',
        contentId: 'Innholds-ID',
        locationId: 'Plassering-ID',
      },
    },
    tasks: {
      passed: 'Riktig',
      unanswered: 'Ubesvart',
      failed: 'Feil',
      completed: 'Fullført',
      started: 'Påbegynt',
      notStarted: 'Ikkje påbegynt',
      combinedOverview: 'Sammendrag',
      totalStudents: 'Antall elevar',
      avgScore: 'Snittscore',
      totalAttempts: 'Antall forsøk',
      perStudent: 'Per elev',
      attempts: 'Forsøk',
      item: 'Oppgåve',
      task: 'Oppgåve',
      tasks: 'Oppgåver',
      timeUsed: 'Tid brukt',
      lastChanged: 'Sist endra',
    },
    task: {
      article: 'Artikkel',
      taskSet: 'Oppgåvesett',
      progression: 'Progresjon',
      taskItem: 'Oppgåve',
      attempts: 'Forsøk',
      time: 'Tid',
      score: 'Poeng',
    },
    noTaskData: 'Ingen oppgåvedata tilgjengeleg',
    errors: {
      notFound: 'Fann ingen aktivitet',
      notWorking: 'Kunne ikkje laste rapport',
    },
  },
  status: {
    notStarted: 'Ikkje påbegynt',
    inProgress: 'Pågår',
    completed: 'Fullført',
  },
  component: {
    openTask: 'Oppgåve',
    openActivity: 'Aktivitet',
    openFormWriter: 'Innlevering',
  },
  type: 'Type',
  score: 'Score',
  percent: 'Prosent',
  digitalBook: {
    title: 'Digital bok',
  },
}

export default nn
